import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./utils/AuthContext";
import CreateAccount from "./components/account-forms/create-account";
import LogInAccount from "./components/account-forms/log-in-account";
import "./main.css";
import { getUserDocument } from "./firebase";
import { extentions, extentionsNames } from "./constants";
import CardsGallery from "./components/cards-gallery/cards-gallery";
import AddCardModal from "./components/add-card-modal/add-card-modal";
import EE from "./components/ee/ee";

import OP01 from "./data/sets/OP01.json"
import OP02 from "./data/sets/OP02.json"
import OP03 from "./data/sets/OP03.json"
import OP04 from "./data/sets/OP04.json"
import OP05 from "./data/sets/OP05.json"
import OP06 from "./data/sets/OP06.json"
import OP07 from "./data/sets/OP07.json"
import OP08 from "./data/sets/OP08.json"
import OP09 from "./data/sets/OP09.json"
import OP10 from "./data/sets/OP10.json"
import OP11 from "./data/sets/OP11.json"
import OP12 from "./data/sets/OP12.json"
import OP13 from "./data/sets/OP13.json"

import EB01 from "./data/sets/EB01.json"
import EB02 from "./data/sets/EB02.json"

import PRB01 from "./data/sets/PRB01.json"
import PRB02 from "./data/sets/PRB02.json"

import ST01 from "./data/decks/ST01.json"
import ST02 from "./data/decks/ST02.json"
import ST03 from "./data/decks/ST03.json"
import ST04 from "./data/decks/ST04.json"
import ST05 from "./data/decks/ST05.json"
import ST06 from "./data/decks/ST06.json"
import ST07 from "./data/decks/ST07.json"
import ST08 from "./data/decks/ST08.json"
import ST09 from "./data/decks/ST09.json"
import ST10 from "./data/decks/ST10.json"
import ST11 from "./data/decks/ST11.json"
import ST12 from "./data/decks/ST12.json"
import ST13 from "./data/decks/ST13.json"
import ST14 from "./data/decks/ST14.json"
import ST15 from "./data/decks/ST15.json"
import ST16 from "./data/decks/ST16.json"
import ST17 from "./data/decks/ST17.json"
import ST18 from "./data/decks/ST18.json"
import ST19 from "./data/decks/ST19.json"
import ST20 from "./data/decks/ST20.json"
import ST21 from "./data/decks/ST21.json"
import ST22 from "./data/decks/ST22.json"
import ST23 from "./data/decks/ST23.json"
import ST24 from "./data/decks/ST24.json"
import ST25 from "./data/decks/ST25.json"
import ST26 from "./data/decks/ST26.json"
import ST27 from "./data/decks/ST27.json"
import ST28 from "./data/decks/ST28.json"

import P from "./data/promos/P.json"

export default function Main({ setNickname }) {
    const { authState } = useContext(AuthContext);

    const [createForm, setCreateForm] = useState(true);
    const [currentTab, setCurrentTab] = useState("all-cards");
    const [userInfo, setUserInfo] = useState(null);
    const [modal, setModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("")
    const [selectedExtentions, setSelectedExtentions] = useState([]);

    const [options, setOptions] = useState({
        displayRarity: false,
        displayMarketPrice: false,
        displayName: true,
        displayID: true
    })


    const [allSets, setAllSets] = useState([]);
    const [ownedCards, setOwnedCards] = useState([])
    const [missingCards, setMissingCards] = useState([])
    const [likedCards, setLikedCards] = useState([])
    const [wishlistedCards, setWishlistedCards] = useState([])

    const [allSetsFiltered, setAllSetsFiltered] = useState([]);
    const [ownedCardsFiltered, setOwnedCardsFiltered] = useState([])
    const [missingCardsFiltered, setMissingCardsFiltered] = useState([])
    const [likedCardsFiltered, setLikedCardsFiltered] = useState([])
    const [wishlistedCardsFiltered, setWishlistedCardsFiltered] = useState([])

    const getLikedCardsCount = (cardsList) => {
        const inter = cardsList.filter(card => likedCards.includes(card))
        const count = inter.length
        return count
    }

    const getGivenRarityCount = (cardsList, rarity) => {
        const filteredCards = cardsList.filter(card => card.rarity == rarity)
        const count = filteredCards.length
        return count
    }

    const getTotalValue = (cardsList, type) => {
        let total = 0
        if (type == "inventory-price") {
            for (const card of cardsList) {
                total += card.inventory_price
            }
        } else {
            for (const card of cardsList) {
                total += card.market_price
            }
        }
        return total.toFixed(2)
    }

    useEffect(() => {
        const getAllSetsData = async () => {
            if (!userInfo) return; // tant qu'on n'a pas userInfo, on sort

            let flatResults = [
                ...OP01,
                ...OP02,
                ...OP03,
                ...OP04,
                ...OP05,
                ...OP06,
                ...OP07,
                ...OP08,
                ...OP09,
                ...OP10,
                ...OP11,
                ...OP12,
                ...OP13,
                
                ...EB01,
                ...EB02,

                ...PRB01,
                ...PRB02,

                ...ST01,
                ...ST02,
                ...ST03,
                ...ST04,
                ...ST05,
                ...ST06,
                ...ST07,
                ...ST08,
                ...ST09,
                ...ST10,
                ...ST11,
                ...ST12,
                ...ST13,
                ...ST14,
                ...ST15,
                ...ST16,
                ...ST17,
                ...ST18,
                ...ST19,
                ...ST20,
                ...ST21,
                ...ST22,
                ...ST23,
                ...ST24,
                ...ST25,
                ...ST26,
                ...ST27,
                ...ST28,

                ...P
            ]

            const seen = new Set();
            flatResults = flatResults.filter(card => {
                const id = card.card_name + card.card_image_id; // fallback au cas où
                if (seen.has(id)) return false;
                seen.add(id);
                return true;
            });

            flatResults.sort((a, b) =>
                (a.card_image_id ?? "ZZZ").localeCompare(b.card_image_id ?? "ZZZ", 'en', { numeric: true })
            );

            const ownedCardsResults = flatResults.filter(card =>
                userInfo.owned_cards.includes(card.card_image_id)
            )

            const missingCardsResults = flatResults.filter(card =>
                !userInfo.owned_cards.includes(card.card_image_id)
            )

            const likedCardsResults = flatResults.filter(card =>
                userInfo.liked_cards.includes(card.card_image_id)
            )

            const wishlistedCardsResults = flatResults.filter(card =>
                userInfo.wishlisted_cards.includes(card.card_image_id)
            )

            setAllSets(flatResults)
            setOwnedCards(ownedCardsResults)
            setMissingCards(missingCardsResults)
            setLikedCards(likedCardsResults)
            setWishlistedCards(wishlistedCardsResults)
        }
        getAllSetsData()
    }, [extentions, userInfo])

    useEffect(() => {
        const fetchUserInfo = async () => {
            if (authState) {
                const userData = await getUserDocument(authState.uid);

                setTimeout(() => {
                    setUserInfo(userData);
                    setNickname(userData.nickname);
                }, 1000);
            }
        };
        fetchUserInfo();
    }, [authState]);

    useEffect(() => {
        setAllSetsFiltered(filterCards(allSets, searchTerm, selectedExtentions));
        setOwnedCardsFiltered(filterCards(ownedCards, searchTerm, selectedExtentions));
        setMissingCardsFiltered(filterCards(missingCards, searchTerm, selectedExtentions));
        setLikedCardsFiltered(filterCards(likedCards, searchTerm, selectedExtentions));
        setWishlistedCardsFiltered(filterCards(wishlistedCards, searchTerm, selectedExtentions));
    }, [selectedExtentions, searchTerm, allSets, ownedCards, missingCards, likedCards, wishlistedCards]);

    const filterCards = (cards, term = "", exts = selectedExtentions) => {
        console.log("filterCards", term, exts);
        console.log("cards", cards);

        return cards.filter((card) => {
            const matchesText =
                card.card_name?.toLowerCase().includes(term) ||
                card.set_name?.toLowerCase().includes(term) ||
                card.sub_types?.toLowerCase().includes(term) ||
                card.card_set_id?.toLowerCase().includes(term);

            const matchesExt =
                exts.length === 0 ||
                exts.some((extId) => card.card_set_id?.includes(extId));

            return matchesText && matchesExt;
            // return matchesText;
        });
    };

    const handleSearch = (e) => {
        e.preventDefault();
        const term = e.target[0].value.toLowerCase();
        setSearchTerm(term);
    };

    const handleChange = (e, ext) => {
        const { checked } = e.target;

        setSelectedExtentions((prev) =>
            checked ? [...prev.filter((id) => id !== ext.id), ext.id] : prev.filter((id) => id !== ext.id)
        );
    };
    
    return <>
        {authState ? (
            !userInfo ? (
                <p>Loading user data...</p>
            ) : (
                <div className="full-width">
                    {/* <pre>{JSON.stringify(ownedCards)}</pre> */}
                    {/* <pre>{JSON.stringify(allSetsFiltered)}</pre>
                    <pre>{JSON.stringify(ownedCardsFiltered)}</pre>
                    <pre>{JSON.stringify(missingCardsFiltered)}</pre> */}

                    <h2 className="">Welcome back, {userInfo.nickname}!</h2>
                    <div class="tabs">
                        <p className={currentTab == "all-cards" ? "current-tab" : undefined} onClick={() => setCurrentTab("all-cards")}>All cards</p>
                        <p className={currentTab == "owned-cards" ? "current-tab" : undefined} onClick={() => setCurrentTab("owned-cards")}>Owned cards</p>
                        <p className={currentTab == "missing-cards" ? "current-tab" : undefined} onClick={() => setCurrentTab("missing-cards")}>Missing cards</p>
                        <p className={currentTab == "liked-cards" ? "current-tab like" : "like"} onClick={() => setCurrentTab("liked-cards")}>Liked cards</p>
                        <p className={currentTab == "wishlisted-cards" ? "current-tab wishlist" : "wishlist"} onClick={() => setCurrentTab("wishlisted-cards")}>Wishlisted cards</p>
                    </div>

                    <form className="search-bar" onSubmit={(e) => handleSearch(e)}>
                        {/* <input onChange={(e) => setSearchTerm(e.target.value)} type="text" placeholder="Search by name, group, set or code" /> */}
                        <input type="text" placeholder="Search by name, group, set or code" />
                        <input type="submit" value="Search" className="cta"/>
                    </form>

                    <div className="extensions-filter">
                        {extentionsNames.map((ext) => (
                            <label key={ext.id} className={selectedExtentions.includes(ext.id) ? "selected" : undefined}>
                                <input type="checkbox" value={ext.id} checked={selectedExtentions.includes(ext.id)} onChange={(e) => handleChange(e, ext)} /> 
                                <img src={`${process.env.PUBLIC_URL}/assets/expansions/${ext.image}`} />
                                <p><b>{ext.id.slice(0, -1)}</b> {ext.name}</p>
                            </label>
                        ))}
                    </div>
                    
                    <button className="add-card-button cta" onClick={() => setModal(true)}>Use a code to add a card to your collection</button>
                        
                    {currentTab == "all-cards" && <>
                        <div className="counts all-cards">
                            {/* Counters for the all-cards tab */}
                            <p>Listed <br /> <span>{allSets.length}</span></p>
                            <p>Owned <br /> <span>{ownedCards.length}</span></p>
                            <p>Missing <br /> <span>{missingCards.length}</span></p>
                            <p>Liked <br /> <span>{likedCards.length}</span></p>
                            <p>Wishlisted <br /> <span>{wishlistedCards.length}</span></p>
                        </div>
                        {(selectedExtentions.length > 0 || searchTerm != "") && <div className="counts all-cards">
                            <p>Selected <br /> <span>{allSetsFiltered.length}</span></p>
                            <p>Owned (Sel.) <br /> <span>{ownedCardsFiltered.length}</span></p>
                            <p>Missing (Sel.) <br /> <span>{missingCardsFiltered.length}</span></p>
                            <p>Liked (Sel.) <br /> <span>{likedCardsFiltered.length}</span></p>
                            <p>Wishlisted (Sel.) <br /> <span>{wishlistedCardsFiltered.length}</span></p>
                        </div>}
                    </>}

                    {currentTab == "owned-cards" && (<>
                        <div className="counts owned-cards">
                            <p>Owned <br /> <span>{ownedCards.length}</span></p>
                            <p>Liked <br /> <span>{getLikedCardsCount(ownedCards)}</span></p>
                            <p>C Rarity <br /> <span>{getGivenRarityCount(ownedCards, "C")}</span></p>
                            <p>UC Rarity <br /> <span>{getGivenRarityCount(ownedCards, "UC")}</span></p>
                            <p>R Rarity <br /> <span>{getGivenRarityCount(ownedCards, "R")}</span></p>
                            <p>SR Rarity <br /> <span>{getGivenRarityCount(ownedCards, "SR")}</span></p>
                            <p>SEC Rarity <br /> <span>{getGivenRarityCount(ownedCards, "SEC")}</span></p>
                            <p>L Rarity <br /> <span>{getGivenRarityCount(ownedCards, "L")}</span></p>
                            <p>SP Rarity <br /> <span>{getGivenRarityCount(ownedCards, "SP")}</span></p>
                            <p>Inventory value <br /> <span>${getTotalValue(ownedCards, "inventory-price")}</span></p>
                            <p>Market value <br /> <span>${getTotalValue(ownedCards, "market-price")}</span></p>
                        </div>

                        {(selectedExtentions.length > 0 || searchTerm != "") && <div className="counts owned-cards">
                            <p>Selected <br /> <span>{ownedCardsFiltered.length}</span></p>
                            <p>Liked (Sel.) <br /> <span>{getLikedCardsCount(ownedCardsFiltered)}</span></p>
                            <p>C Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "C")}</span></p>
                            <p>UC Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "UC")}</span></p>
                            <p>R Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "R")}</span></p>
                            <p>SR Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "SR")}</span></p>
                            <p>SEC Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "SEC")}</span></p>
                            <p>L Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "L")}</span></p>
                            <p>SP Rarity (Sel.) <br /> <span>{getGivenRarityCount(ownedCardsFiltered, "SP")}</span></p>
                            <p>Inventory value (Sel.) <br /> <span>${getTotalValue(ownedCardsFiltered, "inventory-price")}</span></p>
                            <p>Market value (Sel.) <br /> <span>${getTotalValue(ownedCardsFiltered, "market-price")}</span></p>
                        </div>}
                    </>)}

                    <div class="extensions-filter display-options">
                        <label className={options.displayName ? "selected" : undefined}>
                            <input type="checkbox" checked={options.displayName} onChange={() => setOptions({...options, displayName: !options.displayName})}></input>
                            <p>Display card name</p>
                        </label>
                        <label className={options.displayID ? "selected" : undefined}>
                            <input type="checkbox" checked={options.displayID} onChange={() => setOptions({...options, displayID: !options.displayID})}></input>
                            <p>Display card ID</p>
                        </label>
                        <label className={options.displayRarity ? "selected" : undefined}>
                            <input type="checkbox" checked={options.displayRarity} onChange={() => setOptions({...options, displayRarity: !options.displayRarity})}></input>
                            <p>Display card rarity</p>
                        </label>
                        <label className={options.displayMarketPrice ? "selected" : undefined}>
                            <input type="checkbox" checked={options.displayMarketPrice} onChange={() => setOptions({...options, displayMarketPrice: !options.displayMarketPrice})}></input>
                            <p>Display card market price</p>
                        </label>
                    </div>

                    {currentTab == "all-cards" && <CardsGallery mode={"all-cards"} cards={allSetsFiltered} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} likedCards={userInfo.liked_cards} wishlistedCards={userInfo.wishlisted_cards} options={options}/>}
                    {currentTab == "owned-cards" && <CardsGallery mode={"owned-cards"} cards={ownedCardsFiltered} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} likedCards={userInfo.liked_cards} wishlistedCards={userInfo.wishlisted_cards} options={options}/>}
                    {currentTab == "missing-cards" && <CardsGallery mode={"missing-cards"} cards={missingCardsFiltered} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} likedCards={userInfo.liked_cards} wishlistedCards={userInfo.wishlisted_cards} options={options}/>}
                    {currentTab == "liked-cards" && <CardsGallery mode={"liked-cards"} cards={likedCardsFiltered} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} likedCards={userInfo.liked_cards} wishlistedCards={userInfo.wishlisted_cards} options={options}/>}
                    {currentTab == "wishlisted-cards" && <CardsGallery mode={"wishlisted-cards"} cards={wishlistedCardsFiltered} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} likedCards={userInfo.liked_cards} wishlistedCards={userInfo.wishlisted_cards} options={options}/>}

                    {modal && <AddCardModal setModal={setModal} ownedCards={userInfo.owned_cards} setUserInfo={setUserInfo} />}
                </div>
            )
        ) : (
            <main className="medium-width">
                <h2>Please log in to use OPTCG Binder</h2>
                <div className="tabs">
                    <p className={createForm ? "current-tab" : undefined} onClick={() => setCreateForm(true)}>Create an account</p>
                    <p className={createForm ? undefined : "current-tab"} onClick={() => setCreateForm(false)}>Log in to your account</p>
                </div>
                {createForm ? <CreateAccount /> : <LogInAccount />}
            </main>
        )}
        <EE />
    </>

}
